<template>
    <v-container>
        <v-row>
            <v-col lg=4 offset=4>
            
            <v-img
            alt="Vuetify Logo"
            :src="require('../assets/logo.svg')"
            contain
            transition="scale-transition"
            max-height='100'
            max-width="250"
            />
            </v-col>
            
        </v-row>
        <v-row class='mt-15'>
            <div v-if='pendingStatus'>
            <v-col lg=6 offset=3>
                <v-img  :src="require('../assets/loading_checkout.svg')" contain></v-img>
                <p class='text-center mt-10'>Please wait... Confirming Purchase.</p>
            </v-col>
            </div>
            <div v-else>
                    <v-col v-if='orderStatus' lg=6 offset=3>
                    <v-img :src="require('../assets/success_checkout.svg')" contain></v-img>
                    <p class='text-center mt-10'>Hurray! Purchase Successful.</p>
                    <v-btn>Back to Store</v-btn>
                </v-col>
                <v-col v-else lg=6 offset=3>
                    <v-img :src="require('../assets/error_checkout.svg')" contain></v-img>
                    <p class='text-center mt-10'>Oops! Something went wrong, purchase unsuccessful. Please try again!</p>
                    <v-row justify="center">
                        <v-btn class='mt-5'>Back to Cart</v-btn>
                    </v-row>
                    <v-row justify="center">
                         <v-btn class='mt-5'>Back to Store</v-btn>
                    </v-row> 
                </v-col>
            </div>
        </v-row>
    </v-container>
</template>
<script>
/*global myBaseURL*/

import axios from 'axios';

export default {
    name:'CheckoutConfirm',
    data() {
        return {
            pendingStatus : true,
            orderStatus : false,
            intervalId : null,
            pay_id : null
        }
    },
    created(){
        // var urlparams= new URLSearchParams(window.location.search)
        // this.pay_id = urlparams.get('razorpay_payment_id');
        var that = this;
        // if(this.$route.query.razorpay_payment_id)
        // {
        //     this.pay_id = this.$route.query.razorpay_payment_id
        // }
        
        axios.request({
            url: '/razorpay/result/check/?razorpay_payment_id=' + this.pay_id,
            method: 'POST',
            baseURL: myBaseURL
        }).then(response => {
            var flag = 0;
            if(response.data.status == 'captured')
            {
                flag = 1;
                that.pendingStatus = false;
                that.orderStatus = true;
            }
            else if(response.data.status != undefined)
            {
                that.pendingStatus = false;
                that.orderStatus = false;
            }

            if(flag != 1)
            {
                this.checkStatus()
            }
        }).catch(e => {
            console.log(e);
            this.checkStatus()
        });
    },
    methods: ({
        checkStatus()
        {
            // var flag = 0;
            // var pay_id = null;
            var that = this;
            // if(this.$route.query.razorpay_payment_id)
            // {
            //     pay_id = this.$route.query.razorpay_payment_id
            // }
            var i =0 ;
            this.intervalId = setInterval(function() {
                console.log(i);
                if(i == 5)
                {
                    that.pendingStatus = false;
                    that.orderStatus = false;
                    clearInterval(that.intervalId);
                }
                i = i + 1;

                axios.request({
                    url: '/razorpay/result/check/?razorpay_payment_id=' + this.pay_id,
                    method: 'POST',
                    baseURL: myBaseURL
                }).then(response => {
                    console.log(response.data.status);
                    if(response.data.status == 'captured')
                    {
                        // flag = 1;
                        that.pendingStatus = false;
                        that.orderStatus = true;
                        clearInterval(that.intervalId);
                    }
                    else if(response.data.status != undefined)
                    {
                        // flag = 1;
                        that.pendingStatus = false;
                        that.orderStatus = false;
                        clearInterval(that.intervalId);
                    }
                }).catch(e => {
                    // flag = 0;
                    that.pendingStatus = true;
                    that.orderStatus = false;
                    console.log(e);
                });
            }, 3000);
        }
    })
}
</script>